module.exports = "img/button-text-numbered-list-on.8e7d0ec.svg";